import { createContext, useContext } from 'react';
import type { MerchantSettingsPane, MerchantSettingsRequest } from './merchant-settings-context';

interface OpenOptions {
  email?: string;
  pane?: MerchantSettingsPane;
  highlight?: string;
}

interface MerchantSettingsContextValue {
  request: MerchantSettingsRequest | 'picker' | null;
  openMerchantSettings: (merchantId: string | number, options?: OpenOptions) => void;
  openMerchantPicker: () => void;
  closeMerchantSettings: () => void;
  selectWaitingMerchant: (merchantId: string | number, email?: string) => void;
}

export const MerchantSettingsContext = createContext<MerchantSettingsContextValue | null>(null);

export function useMerchantSettings() {
  const value = useContext(MerchantSettingsContext);
  if (!value) {
    throw new Error('Merchant settings are available inside the cabinet shell');
  }
  return value;
}
